export default "__VITE_ASSET__797309e9__"